module.exports = __webpack_public_path__ + "static/media/rebirth_3.1fbfc55d.jpg";